import { FeatureAppLoader } from '@feature-hub/react';
import {
  Breakpoints,
  Container,
  IntegratorRoot,
  Layout,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { History } from 'history';
import React from 'react';

import {
  Content,
  FaContentServiceV1,
} from '@volkswagen-onehub/fa-content-service';

import { Route, Router, Switch } from 'react-router-dom';
import { appsCommonsJS, appsUMD } from './app-constants';
import Ngw6AppRender from './components/ngw6-app-render';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import {
  contentFeatureAppMap,
  getConfigsFeatureApp,
} from './feature-app-helpers';

export interface IntegratorProps extends ModelOverviewIntegratorOptions {
  readonly history: History;
}

export function Integrator({
  baseUrl,
  history,
  ssr,
  featureAppName = 'default',
  ...props
}: IntegratorProps): JSX.Element {
  const featureAppConfig = getConfigsFeatureApp({
    ...props,
    featureAppName,
  });

  return (
    <IntegratorRoot>
      <ThemeProvider>
        <Layout
          appearance={{
            [Breakpoints.default]: [
              { name: '.', columns: 0 },
              { name: 'a', columns: 24 },
              { name: '.', columns: 0 },
            ],
            // [Breakpoints.b960]: [
            //   { name: '.', columns: 2 },
            //   { name: 'a', columns: 20 },
            //   { name: '.', columns: 2 },
            // ],
          }}
          allowOverflowingContent
        >
          <Container
            wrap="always"
            padding={{
              top: 'static0',
              bottom: 'static350',
            }}
            gutter="static500"
          >
            <Router history={history}>
              <Switch>
                <Route
                  exact
                  path="/"
                  render={() => (
                    <FeatureAppLoader
                      featureAppId="maintenance"
                      baseUrl={baseUrl}
                      src={appsUMD[featureAppName]}
                      serverSrc={
                        ssr ? appsCommonsJS[featureAppName] : undefined
                      }
                      config={featureAppConfig}
                      beforeCreate={({ featureServices }) => {
                        const content: Content =
                          contentFeatureAppMap[featureAppName];

                        if (content) {
                          (
                            featureServices[
                              'fa-content-service'
                            ] as FaContentServiceV1
                          ).content = content;
                        }
                      }}
                    />
                  )}
                />
                <Route
                  path="/application-render/:appId"
                  render={() => (
                    <Ngw6AppRender isSsr={ssr} baseUrl={baseUrl} {...props} />
                  )}
                />
              </Switch>
            </Router>
          </Container>
        </Layout>
      </ThemeProvider>
    </IntegratorRoot>
  );
}
